import { DocTypes } from "../constants/DocTypes";

/**
 * Doc types whose `description` value coming from `ROIS_TransactionDocument_sel`
 * is a literal label ("Request" / "Affidavit" / "Invoice") or an empty string,
 * rather than a real file name. INVOICE is not part of the {@link DocTypes} enum
 * so it is matched as a raw string, consistent with the rest of the codebase.
 */
const STORED_NAME_FIRST_ROLES: ReadonlySet<string> = new Set<string>([
    DocTypes.REQ,
    DocTypes.AUX,
    "INVOICE",
]);

export const NO_FILE_NAME = "no file name";

/**
 * Resolves the label shown for a document in the read-only / completed transaction
 * file dropdown.
 *
 * For Request / Affidavit / Invoice documents the stored proc returns a literal
 * label (e.g. "Request") or an empty string in `description`, while the real,
 * stable file name lives in `file.name`. For those types we prefer `file.name` so
 * the dropdown shows the actual file name regardless of which stored-proc build is
 * deployed to the environment.
 *
 * For every other doc type (Medical, Internal, etc.) `description` is the
 * user-entered label and `file.name` is an opaque GUID, so we keep `description`
 * first to avoid regressing those.
 *
 * See Bug 31938.
 */
export function getReadOnlyDocumentName(file: any): string {
    const role: string | undefined = file?.type?.role ?? file?.recType;
    const description: string | undefined = file?.description;
    const storedFileName: string | undefined = file?.file?.name;

    const name = STORED_NAME_FIRST_ROLES.has(role ?? "")
        ? storedFileName || description
        : description || storedFileName;

    return name && name.length > 0 ? name : NO_FILE_NAME;
}
